const BE_HOST = process.env.REACT_APP_BE_HOST
const FE_HOST = process.env.REACT_APP_FE_HOST
const TEST_URL = process.env.REACT_APP_TEST_URL
const DEMO_URL = process.env.REACT_APP_DEMO_URL
const BOTPRESS_URL = "https://chat.botpress.cloud/"
const WEb_ID = "f2e431f6-1dab-4658-969a-a6687730569d"
const USER_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpZCI6InVzZXJfMDFLR1ZTRVI1MFc5QjlWWUtUWFlGOTU4RlYiLCJpYXQiOjE3NzA0NTkxOTN9.n5AVU5P4YnI80oP3FA4We8pyORZ0wYnlmGmCOSKzNBY"
const BOT_ID = "30e78533-38fb-4df5-b34f-20c5bdb2af36"
const CONV_ID = "conv_01KGVZHZEFMY3CAD2D4K2YPNGE"
// const	BE_HOST = 'https://414233442.xyz'
module.exports = {
    BE_HOST,
    FE_HOST,
    TEST_URL,
    DEMO_URL,
    BOTPRESS_URL,
    BOT_ID,
    CONV_ID,
    USER_KEY,
    WEb_ID
}